module.exports = {
  USER_ACTIVITY: 'User activity',
  PATIENT_OUTCOMES: 'Patient Outcomes',
  ENROLLMENTS: 'Enrollments',
};
